/**
 * legacyAdapter.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Adapter helper to normalize legacy configurations into standard manifests.
 * Converts old theme overrides and slot mappings at load-time.
 */

export function adaptLegacyTemplate(legacyConfig) {
  if (!legacyConfig) return null;

  // Resolve target collection ID from legacy attributes
  let collectionId = 'ats_professional';
  if (legacyConfig.category) {
    collectionId = legacyConfig.category;
  } else if (legacyConfig.id === 'faang-engineering') {
    collectionId = 'developer';
  } else if (legacyConfig.id === 'executive-professional') {
    collectionId = 'executive';
  } else if (legacyConfig.id === 'campus-placement' || legacyConfig.id === 'internship-hunter' || legacyConfig.id === 'fresher-plus') {
    collectionId = 'student';
  } else if (legacyConfig.id === 'finance-pro') {
    collectionId = 'finance';
  } else if (legacyConfig.id === 'product-consulting') {
    collectionId = 'modern_professional';
  } else if (legacyConfig.id === 'creative-professional') {
    collectionId = 'creative';
  }

  const cleanId = legacyConfig.id;

  const adapted = {
    id: cleanId,
    name: legacyConfig.name || cleanId,
    collection: collectionId,
    layout: legacyConfig.layout || 'single-column',
    theme: legacyConfig.theme || 'classic-navy',
    density: legacyConfig.metadata?.density || 'comfortable',
    sectionOrder: Array.isArray(legacyConfig.sectionOrder) ? legacyConfig.sectionOrder : [],
    components: legacyConfig.components || {},
    layouts: legacyConfig.layouts || {
      [legacyConfig.layout || 'single-column']: {
        component: legacyConfig.layout || 'single-column',
        slots: {
          header: ['personal-info'],
          main: ['summary', 'experience', 'projects', 'education', 'skills']
        },
        overrides: legacyConfig.styleOverrides || {}
      }
    },
    variants: {
      default: legacyConfig.theme || 'classic-navy',
      themes: {
        [legacyConfig.theme || 'classic-navy']: legacyConfig.styleOverrides || {}
      }
    },
    capabilities: {
      photo: !!legacyConfig.metadata?.photo,
      sidebar: (legacyConfig.layout || '').includes('sidebar'),
      icons: !!legacyConfig.metadata?.icons,
      timeline: false,
      metrics: false,
      languageBars: false,
      skillBars: false,
      projectCards: false,
      achievementsGrid: false,
      charts: false,
      qrCode: false,
      signature: false
    },
    compatibility: {
      recommendedRoles: legacyConfig.metadata?.recommendedFor || [],
      difficulty: 'easy'
    },
    print: {
      paper: 'A4',
      safeMargin: 24,
      avoidPageBreakSections: ['experience']
    },
    version: {
      manifest: legacyConfig.version || 2,
      theme: 1,
      layout: 1
    }
  };

  return adapted;
}

export default adaptLegacyTemplate;
